import React from 'react';
import { motion } from 'framer-motion';
import { useAuth } from '../context/AuthContext';
import ChatInterface from '../components/Chat/ChatInterface';

const ChatPage = () => {
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-white mb-4">Welcome to Gandalf</h1>
          <p className="text-gray-400 mb-6">Please sign in to chat with your AI assistant.</p>
          <a 
            href="/signin" 
            className="inline-flex items-center px-4 py-2 bg-primary hover:bg-primary-dark text-white rounded-lg transition-colors"
          >
            Sign In
          </a>
        </div>
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="fixed inset-0 bg-gray-900 z-10"
    >
      <ChatInterface />
    </motion.div>
  );
};

export default ChatPage; 